
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {mixin as Clickaway} from 'vue-clickaway';
import {SweetModal} from 'sweet-modal-vue';
import Countries from '@/modules/Countries.vue';
import NevronInput from '../../components/NevronInput.vue';
import {showToaster} from '@/components/DashboardComposer/helpers';
import {bus,translate,enableSubmitButton, disableSubmitButton, resetForm,translatedDisplayName} from "@/helpers/functions";

@Component({
  components: {
    SweetModal,
    Countries,
    NevronInput,
  },
  mixins: [Clickaway],
})
export default class EditWeatherlocation extends Vue {
  @Prop()
  item!: IWeatherLocation;
  @Prop()
  module!: any;

  formValidated: boolean = false;
  newWeatherLocation: IWeatherLocation | null = null;

  mounted() {
    this.setItemFromProp();
  }

  @Watch('item', {immediate: true})
  setItemFromProp() {
    if(this.item) {
      this.resetNewWeatherLocation();
      this.$nextTick(this.setupForm);
    }
  }

  get formId() {
    return 'edit-weather'
  }

  resetNewWeatherLocation() {
    this.newWeatherLocation = {
      ...this.item,
      city: translate(this.item.city)
    };
  }

  setupForm() {
    enableSubmitButton(this.formId);
    const form = this.$refs[this.formId] as HTMLFormElement;
    form.removeEventListener('submit', this.handleFormSubmit);
    form.addEventListener('submit', this.handleFormSubmit, { once: true });
  }

  handleFormSubmit(event: Event) {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    if (form.checkValidity()) {
      event.stopPropagation();
      this.save();
    }
    this.formValidated = true;
  }

  countrySelected(country: string) {
    this.newWeatherLocation!.country = country;
  }
  timezone_onChange( zone: string )
  {
  //Update timezone.
    this.newWeatherLocation!.timezone = zone;
  }

  deleteLocation() {
    if (confirm('Do you really want to delete this Location?')) {
      this.module.deleteItem(this.newWeatherLocation!.id)
        .then((response: any) => {
          if (!response.success) {
            throw new Error(response.error.message);
          }
          showToaster('success', translate(this.newWeatherLocation?.city), translate('successfully-deleted'))
          this.$emit('save');
          this.cancel();
        })
        .catch((error: any) => {
          showToaster('danger', '', error);
        });
    }
  }

  roundLat(val: string) {
    if(this.newWeatherLocation) {
      this.newWeatherLocation.latitude = parseFloat(val);
    }
  }

  roundLong(val: string) {
    if(this.newWeatherLocation) {
      this.newWeatherLocation.longitude = parseFloat(val);
    }
  }

  save() {
    disableSubmitButton(this.formId);
    this.module.updateItem(this.newWeatherLocation!.id, this.newWeatherLocation)
      .then((response: any) => {
        if (!response.success) {
          throw new Error(response.error.message);
        }
        showToaster('success', translate(this.newWeatherLocation?.city), translate('successfully-updated'));
        this.$emit('save', this.newWeatherLocation);
        this.cancel();
      })
      .catch((error: any) => {
        enableSubmitButton(this.formId);
        showToaster('danger', '', error);
      });
  }

  cancel(): void {
    // @ts-ignore
    this.$children[0].close();
    this.formValidated = false;
    this.resetNewWeatherLocation();
  }

  openTranslator(localText: any, localKey: any, referenceKey: any) {
    bus().$emit('openTranslator', localText, localKey, referenceKey);
  }
}
